import { BehaviorSubject } from "rxjs";
import { EventEmitter } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { IFilter } from "../services/IFilter";
import { AuthService } from "../services/auth.service";

export class CmdbDatabasesFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService) {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(value:any) {
    this.companyIdChange.next(value);
    this.emitChange("companyId", value);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(value:any) {
    this.nameChange.next(value);
    this.emitChange("name", value);
  }

  descriptionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get description():any {
    return this.descriptionChange.value;
  }
  set description(value:any) {
    this.descriptionChange.next(value);
    this.emitChange("description", value);
  }

  activeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get active():any {
    return this.activeChange.value;
  }
  set active(value:any) {
    this.activeChange.next(value);
    this.emitChange("active", value);
  }

  applicationIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get applicationId():any {
    return this.applicationIdChange.value;
  }
  set applicationId(value:any) {
    this.applicationIdChange.next(value);
    this.emitChange("applicationId", value);
  }

  environmentIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get environmentId():any {
    return this.environmentIdChange.value;
  }
  set environmentId(value:any) {
    this.environmentIdChange.next(value);
    this.emitChange("environmentId", value);
  }

  sqlServerTypeIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get sqlServerTypeId():any {
    return this.sqlServerTypeIdChange.value;
  }
  set sqlServerTypeId(value:any) {
    this.sqlServerTypeIdChange.next(value);
    this.emitChange("sqlServerTypeId", value);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.description && this.description !== '') {
      params = params.set("description", this.description);
    }
    if (this.active && this.active !== '') {
      params = params.set("active", this.active);
    }

    if (this.applicationId) {
      params = params.set("applicationId", this.applicationId);
    }
    if (this.environmentId) {
      params = params.set("environmentId", this.environmentId);
    }
    if (this.sqlServerTypeId) {
      params = params.set("sqlServerTypeId", this.sqlServerTypeId);
    }
    return params;
  }

  setFilters(props: any): void {
    this.sqlServerTypeIdChange.next(props.sqlServerTypeId || undefined);
    this.environmentIdChange.next(props.environmentId || undefined);
    this.applicationIdChange.next(props.applicationId || undefined);
    this.companyIdChange.next(props.companyId === undefined ? this.auth.getCompanyId() : props.companyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.descriptionChange.next(props.description || undefined);
    this.activeChange.next(props.active || undefined);
  }

  toObj() {
    let obj:any = {};

    obj.companyId = this.companyId;
    obj.applicationId = this.applicationId;
    obj.environmentId = this.environmentId;
    obj.sqlServerTypeId = this.sqlServerTypeId;
    obj.name = this.name;
    obj.description = this.description;
    obj.active = this.active;

    return obj;
  }

  public clear():void {
    this.sqlServerTypeId = undefined;
    this.environmentId = undefined;
    this.applicationId = undefined;
    this.companyId = this.auth.getCompanyId();
    this.name = undefined;
    this.description = undefined;
    this.active = undefined;
  }
}
